import React, {useEffect, useState} from "react";
import Api from "../../tools/service";
import {useNavigate} from "react-router-dom";
import {Reoverlay} from "reoverlay";
import InitConfirm from "../../components/carOriginality/InitConfirm";
import Swal from "sweetalert2";
import {TbShieldCheckFilled} from "react-icons/tb";
import CreatePaymentCard from "../../components/carOriginality/CreatePaymentCard";
import Button from "../../components/Button";
import ProgressBar from "../../components/ProgressBar";
import BugModal from "../../components/BugModal";
import {MdClose} from "react-icons/md";
import {BiSupport} from "react-icons/bi";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import {calculateOtpTimer, divarLinkGenerator, persianToEnglish, safeRedirect} from "../../tools/helpers";
import CarServicesConfirmModal from "../../components/modals/CarServicesConfirmModal";
import OTP from "../../components/carOriginality/OTP";
import requestOTP from "../../tools/api/cservice/requestOTP";
import confirmOTP from "../../tools/api/cservice/confirmOTP";
import ErrorModal from "../../components/modals/ErrorModal";
import useDivarAuth from "../../hooks/useDivarAuth";

const otpConfig = {
    title: 'کد اعتبار سنجی',
    length: 5,
}
const CarOriginality = () => {
    const {token,platformUser,returnUrl,postToken}=useDivarAuth();
    const [loadingMessage, setLoadingMessage] = useState('لطفا منتظر بمانید');
    const [selectedServiceCount, setSelectedServiceCount] = useState(0);
    const [processInfo, setProcessInfo] = useState(null);
    const [pid, setPid] = useState(null)
    const mobile = platformUser ? platformUser.phone_number : null;
    const [isLoading, setLoading] = useState(true)
    const [selectedServices, setSelectedServices] = useState([])
    const [prices, setPrices] = useState([]);
    const navigate = useNavigate();
    const [bugReportData, setBugReportData] = useState(null)
    const [showReport, setShowReport] = useState(false)
    const [openReportModal, setOpenReportModal] = useState(false);
    const [showSupportActions, setShowSupportActions] = useState(false);
    const [otpRequired, setOtpRequired] = useState(false);
    const [otpRequestLoading, setRequestOtpLoading] = useState(false);
    const [otpConfirmLoading, setOtpConfirmLoading] = useState(false);
    const [otpError, setOtpError] = useState(false);
    const [otpTimer, setOtpTimer] = useState(120)
    const [otpDescription, setOtpDescription] = useState(null)
    useEffect(() => {
        Api.get('/api/v1/options').then((response) => {
            if (!response.hasError) {
                if (response.data) {
                    response.data.forEach((item) => {
                        if (item.key === "report_settings") {
                            setShowReport(true)
                            setBugReportData(JSON.parse(item.value));

                        }
                    })
                }
            }
        })
    }, []);
    useEffect(() => {
        handleInquiryProcess();
    }, []);
    const handleInquiryProcess = () => {
        Api.get(REQUEST_URLS.CAR_SERVICES.INQUIRY_PROCESS, {
            params: {
                post_token: postToken
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, hasError,status,message} = response;
            if (!hasError) {
                if (!!data?.process && !!data?.process?.pid) {
                    if (data?.process?.widget.has_widget) {
                        setPid(pid)
                        Reoverlay.showModal(CarServicesConfirmModal, {
                            title: "اصالت خودرو",
                            "token": token,
                            "widget": data?.process?.widget,
                            onContinue: () => {
                                if (data?.process?.pid && data?.process?.current_step?.name !== 'final') {
                                    setPid(data.process.pid);
                                    handleGetProcess(data?.process?.pid);
                                } else {
                                    handleCreateProcess();
                                }

                            },
                            onDelete: (deleteType, pieceName) => {
                                handleCarServiceWidget(deleteType, pieceName, data?.process?.pid,postToken, () => {
                                    handleCreateProcess();
                                })


                            }

                        })
                    } else {
                        setPid(data?.process?.pid);
                        handleGetProcess(data?.process?.pid);

                    }

                } else {
                    handleCreateProcess();
                }
            } else {
                handleError({status,data,message,pid,callback:()=>{
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: false,
                            confirmButtonColor: '#d51e3e',
                            confirmButtonText: 'تلاش مجدد',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                handleInquiryProcess()
                            }
                        })
                    }})
            }

        })
    }
    const handleRequestOTP = async () => {
        setRequestOtpLoading(true);
        setOtpError(null);

        const response = await requestOTP(token, {pid});
        handleLoading(false);
        setRequestOtpLoading(false)
        if (response.hasError) {
            setOtpError(response.message);
        } else {
            const time = calculateOtpTimer(response.data.created_at, 120);
            setOtpTimer(time);
            setOtpRequired(true)
            setOtpDescription(response.message)
        }
    }
    const handleConfirmOTP = async (value) => {
        setOtpConfirmLoading(true);
        setOtpError(null);
        const params={pid, code: persianToEnglish(value)}
        const response = await confirmOTP(token, params);
        setOtpConfirmLoading(false)
        if (response.hasError) {
            setOtpError(response.message);

        } else {

            handleGetProcess(pid)
        }
    }
    const handleLoading = (loading, message = 'لطفا منتظر بمانید') => {
        setLoading(loading);
        setLoadingMessage(message)
    }
    const handleRedirectToDivar = ({price, status}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price,
            status,

        });
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal, {
                showConfirmButton: true,
                confirmButtonText: 'بستن',
                confirmButtonTheme: 'red',
                message: 'لینک معتبر نمی باشد.',
                title: 'خطا',
                onConfirm: () => {

                    Reoverlay.hideModal()
                    navigate('/404')
                }
            })
        })
    }
    useEffect(() => {

        if (selectedServices) {

            selectedServices.forEach((item) => {
                if (item.default_selected || item.isSelected) {

                    setSelectedServiceCount(selectedServiceCount + 1)
                }
            })
        }
    }, [selectedServices])
    const handleGetProcess = (pid) => {

        handleLoading(true, 'در حال دریافت اطلاعات');

        Api.get(REQUEST_URLS.CAR_SERVICES.FETCH_PROCESS, {
            params: {
                pid: pid,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, hasError, status, message} = response;
            if (!hasError) {

                setPrices(data?.options.prices)
                setSelectedServices(data?.options.services);
                let newServices = []
                if (data?.options.services) {
                    data?.options?.services.forEach((item, index) => {
                        if (data.process.selected_items.includes(item.name)) {
                            const newSelected = {
                                ...item,
                                default_selected: true,
                            }
                            newServices.push(newSelected)
                        } else {
                            newServices.push(item)
                        }
                    });
                    setSelectedServices(newServices)
                }
                setProcessInfo(data?.process);
                if (data?.process.current_step.name === 'Shahkar') {
                    handleShahkar(pid);
                } else if (data?.process.current_step.name === "CarCardInquiry") {
                    handleCarCardInquiry(pid);
                } else if (data?.process.current_step.name === "CarModelInquiry") {
                    handleCarModelInquiry(pid);
                } else if (data?.process.current_step.name === "InsuranceInquiry") {
                    handleInsuranceInquiry(pid);
                } else if (data?.process.current_step.name === 'final') {
                    localStorage.removeItem('pid')
                    handleLoading(false)
                } else {
                    handleLoading(false)
                }
            } else {

                handleError({
                    message, status, data, callback: () => {
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: true,
                            cancelButtonColor: '#d51e3e',
                            confirmButtonColor: '#1e21d5',
                            confirmButtonText: 'تلاش مجدد',
                            cancelButtonText: 'بازگشت',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                handleGetProcess(pid);
                            } else {
                                handleRedirectToDivar({status: "fail", price: processInfo?.payment?.info?.init_amount})
                            }
                        })
                    }
                })
            }
        }).catch((e) => {


        }).finally(() => {

        })
    };
    const handleShahkar = (pid) => {
        setOtpRequired(false);
        setOtpError(null);
        setOtpDescription(null);

        handleLoading(true, 'در حال تطابق کد ملی و شماره موبایل');
        handleGenerateUuid('Shahkar').then((uuid) => {
            const data = {
                pid: pid,
                uuid: uuid,
            }
            Api.post(REQUEST_URLS.CAR_SERVICES.SHAHKAR, data, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(pid)

                } else {
                    handleError({
                        pid, message, status, data, callback: () => {
                            Swal.fire({
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                confirmButtonText: 'تلاش مجدد',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleShahkar(pid)
                                }
                            })
                        }
                    })
                }
            }).catch((e) => {


            }).finally(() => {

            })
        }).catch(() => {

        })

    };
    const handleCreateProcess = () => {
        //1
        handleLoading(true, 'در حال ساخت فرایند');
        const data = {
            "platform_user_id": mobile,
            "post_token": postToken,
        };

        Api.post(REQUEST_URLS.CAR_SERVICES.CREATE_PROCESS, data, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {data, message, status, hasError} = response;
            if (!hasError) {
                if (data) {
                    setPid(data.pid);
                    handleGetProcess(data.pid);
                }
            } else {
                if(status===-41){
                    Swal.fire({
                        text:message,
                        title:'ناموفق',
                        icon:'error',
                        backdrop: true,
                        focusConfirm: false,
                        showCancelButton: true,
                        cancelButtonColor: '#d51e3e',
                        cancelButtonText: 'بازگشت',
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(result=>{
                        if(!result.isConfirmed){
                            handleRedirectToDivar({price:0,status:'fail'})
                        }
                    })
                }else if(status===-40){
                    Swal.fire({
                        text:message,
                        title:'ناموفق',
                        icon:'error',
                        backdrop: true,
                        focusConfirm: false,
                        showCancelButton: true,
                        cancelButtonColor: '#d51e3e',
                        cancelButtonText: 'تلاش مجدد',
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(result=>{
                        if(!result.isConfirmed){
                            handleCreateProcess();
                        }
                    })
                }else {
                    handleError({
                        pid,
                        message, status, data, callback: () => {
                            Swal.fire({
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: true,
                                cancelButtonColor: '#d51e3e',
                                confirmButtonColor: '#1e21d5',
                                confirmButtonText: 'تلاش مجدد',
                                cancelButtonText: 'بازگشت',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleCreateProcess();
                                } else {
                                    handleRedirectToDivar({status: "fail", price: 0})
                                }
                            })
                        }
                    })
                }

            }
        }).catch(() => {

        })
    }
    const handleInitConfirm = (values) => {
        const data = {
            ...values,
            pid: pid,
        };

        handleLoading(true, 'در حال ارسال اطلاعات')
        Api.put(REQUEST_URLS.CAR_SERVICES.INIT_CONFIRM, data, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(async (response) => {
            const {data, hasError, message, status} = response;
            if (!hasError) {
                if (data.otp_required) {
                    setOtpRequired(true);
                    handleLoading(false);
                    await handleRequestOTP();
                } else {
                    setOtpRequired(false);
                    handleGetProcess(pid)
                }

            } else {
                handleLoading(false)
                handleError({
                    pid,
                    message, status, data, callback: () => {
                        Swal.fire({
                            text: message,
                            title: "ناموفق",
                            icon: 'error',
                            backdrop: true,
                            focusConfirm: false,
                            showCancelButton: false,
                            confirmButtonColor: '#d51e3e',
                            confirmButtonText: 'بستن',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {

                            } else {

                            }
                        })
                    }
                })
            }
        }).catch(() => {
            handleLoading(false)
        }).finally(() => {

        })

    }
    const handleCreatePayment = (redirect = true) => {
        if (processInfo?.payment?.payment_required && !processInfo?.payment?.paid) {

            handleLoading(true, 'در حال انتقال به درگاه بانکی')
            const data = {
                "pid": pid,
            }
            Api.post(REQUEST_URLS.CAR_SERVICES.GET_PEC_PAYMENT_ORDER_ID, data, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {

                const {hasError, status, message, data} = response;

                if (!hasError) {
                    if (redirect) {
                        safeRedirect(data?.data.pay_url,()=>{
                            handleLoading(false)
                            Reoverlay.showModal(ErrorModal,{
                                title:'خطا',
                                message:'لینک معتبر نمی باشد.',
                                showCancelButton: true,
                                cancelButtonText:'بستن',
                                onCancel:()=>{
                                    Reoverlay.hideModal();
                                    navigate('/404')
                                }
                            })
                        })

                    } else {

                        handleLoading(false)
                    }


                } else {
                    /*         Swal.fire({
                                 allowOutsideClick:false,
                                 text:message,
                                 title: "ناموفق",
                                 icon: 'error',
                                 showCancelButton: false,
                                 confirmButtonColor: '#d51e3e',
                                 showConfirmButton:true,
                                 confirmButtonText:'تلاش مجدد',
                             });*/
                    handleLoading(false)
                    handleError({
                        pid,
                        message, status, data, callback: () => {
                            Swal.fire({
                                allowOutsideClick: false,
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                showConfirmButton: true,
                                confirmButtonText: 'تلاش مجدد',
                            });
                            handleLoading(false)
                        }
                    })
                }

            }).catch(e => {
                console.log(e)
                handleLoading(false)
            })
        }


    }
    const updateStep = (newStep) => {
        setProcessInfo({
            ...processInfo,
            current_step: newStep
        })
    }
    const handleGenerateUuid = async (type) => {
        try {
            const response = await Api.post('/api/v1/Providers/GenUuidV2', {
                request_type: type,
                callback_url: "https://venesh.ir"
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (response && !response.hasError) {

                return response.data.uuid;
            } else {

                Swal.fire({
                    text: response.message,
                    title: "ناموفق",
                    icon: 'error',
                    backdrop: true,
                    focusConfirm: false,
                    showCancelButton: false,
                    confirmButtonColor: '#d51e3e',
                    confirmButtonText: 'تلاش مجدد',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,


                }).then((result) => {

                    if (result.isConfirmed) {

                    } else if (result.isDenied) {
                    }

                });

                throw new Error(response.message)
            }


        } catch (error) {
            console.log(error)
            throw new Error(error.message);
        }
    };
    const handleCarCardInquiry = (pid) => {
        handleLoading(true, 'در حال استعلام کارت خودرو')
        handleGenerateUuid('CarCardInquiry').then((uuid) => {
            Api.post(REQUEST_URLS.CAR_SERVICES.CAR_CARD_INQUIRY, {
                pid: pid,
                uuid: uuid,

            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;

                if (!hasError) {
                    handleGetProcess(pid)

                } else {

                    handleError({
                        pid, message, status, data, callback: () => {
                            Swal.fire({
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                confirmButtonText: 'بستن',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {

                                } else {

                                }
                            })
                        }
                    })

                }

            }).catch(() => {

            }).finally(() => {

            })
        }).catch(() => {

        })
    }
    const handleSkipInsurance = (status) => {
        if (status == -5) {
            handleLoading(true, 'لطفا منتظر بمانید')
            Api.put(REQUEST_URLS.CAR_SERVICES.SKIP_INSURANCE, {
                pid: pid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(pid)
                } else {
                    Swal.fire({
                        text: message,
                        title: "ناموفق",
                        icon: 'error',
                        backdrop: true,
                        focusConfirm: false,
                        showCancelButton: false,
                        confirmButtonColor: '#d51e3e',
                        confirmButtonText: 'تلاش مجدد',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            handleSkipInsurance(status)
                        } else {

                        }
                    })
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {

            })
        } else {
            Swal.fire({
                text: 'با رد شدن از این مرحله، افزونه مربوط به بیمه شما درج نخواهد شد.',
                title: "آیا مطمئن هستید؟",
                icon: 'info',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonColor: '#477be8',
                cancelButtonColor: '#e84747',
                confirmButtonText: 'رد کردن ',
                cancelButtonText: 'تلاش مجدد',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(result => {
                if (result.isConfirmed) {
                    handleLoading(true, 'لطفا منتظر بمانید')
                    Api.put(REQUEST_URLS.CAR_SERVICES.SKIP_INSURANCE, {
                        pid: pid,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        },
                    }).then((response) => {
                        const {data, hasError, status, message} = response;
                        if (!hasError) {
                            if (data?.next_step.name === 'final') {

                                updateStep(data.next_step);
                                localStorage.removeItem('pid')
                            } else {
                                updateStep(data.next_step);
                            }
                        } else {
                            Swal.fire({
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                confirmButtonText: 'تلاش مجدد',
                                cancelButtonText: 'رد کردن',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {

                                } else {
                                    handleSkipInsurance()
                                }
                            })
                        }
                    }).catch((e) => {
                        console.log(e)
                    }).finally(() => {
                        handleLoading(false)
                    })
                } else {
                    handleInsuranceInquiry(pid)
                }
            })
        }

    }
    const handleInsuranceInquiry = (pid) => {
        handleLoading(true, 'در حال استعلام بیمه');
        handleGenerateUuid('InsuranceInquiry').then((uuid) => {
            Api.post(REQUEST_URLS.CAR_SERVICES.INSURANCE_INQUIRY, {
                pid: pid,
                uuid: uuid,

            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;

                if (!hasError) {
                    handleGetProcess(pid)
                } else {
                    handleError({
                        pid,
                        message, status, data, hasSkip: true, onSkip: () => {
                            handleSkipInsurance()
                        }, callback: () => {
                            Swal.fire({
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: true,
                                cancelButtonColor: '#d51e3e',
                                confirmButtonColor: '#477be8',
                                cancelButtonText: 'تلاش مجدد',
                                confirmButtonText: 'رد کردن',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleSkipInsurance();
                                } else {
                                    handleGetProcess(pid);
                                }
                            })
                        }
                    })
                }

            }).finally(() => {

            })
        }).catch(() => {

        })
    }
    const handleCarModelInquiry = (pid) => {
        handleLoading(true, 'در حال استعلام مدل خودرو');
        handleGenerateUuid('CarModelInquiry').then((uuid) => {
            Api.post(REQUEST_URLS.CAR_SERVICES.CAR_MODEL_INQUIRY, {
                pid: pid,
                uuid: uuid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;

                if (!hasError) {
                    handleLoading(true);
                    handleGetProcess(pid);
                } else {
                    handleError({
                        pid,
                        message, status, data, callback: () => {
                            Swal.fire({
                                text: message,
                                title: "ناموفق",
                                icon: 'error',
                                backdrop: true,
                                focusConfirm: false,
                                showCancelButton: false,
                                confirmButtonColor: '#d51e3e',
                                confirmButtonText: 'تلاش مجدد',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleCarModelInquiry(pid)
                                } else {

                                }
                            })
                        }
                    })
                }

            })
        })
    }
    const handleError = ({
                             pid,
                             message,
                             hasSkip = false,
                             onSkip = () => {
                             },
                             status,
                             data,
                             callback = () => {
                             }
                         }) => {
        if (status === -9) {
            Swal.fire({
                text: message,
                title: "ناموفق",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: true,
                cancelButtonColor: '#d51e3e',
                cancelButtonText: 'بازگشت به دیوار',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {

                } else {
                    handleRedirectToDivar({status: "fail", price: processInfo?.payment?.info?.init_amount})
                }
            })
        } else if (status === 403 || status === 401) {
            Swal.fire({
                text: message,
                title: "ناموفق",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: true,
                cancelButtonColor: '#d51e3e',
                cancelButtonText: 'بازگشت به دیوار',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {

                } else {
                    handleRedirectToDivar({status:null,price:null})
                }
            })
        } else if (status === 801 || status === 802 || status === 803 || status === -100 || status === 805) {
            Swal.fire({
                text: message,
                title: "ناموفق",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: false,
                confirmButtonColor: '#d51e3e',
                confirmButtonText: 'شروع مجدد',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {

                    handleCreateProcess()
                } else {

                }
            })


        } else if (data && data?.can_reset) {
            Swal.fire({
                allowOutsideClick: false,
                text: message,
                title: "ناموفق",
                icon: 'error',
                showCancelButton: true,
                cancelButtonColor: '#d51e3e',
                confirmButtonColor: '#2563eb',
                confirmButtonText: 'رد کردن',
                showConfirmButton: hasSkip,
                cancelButtonText: data && data?.can_reset ? 'ویرایش اطلاعات' : 'شروع مجدد',

            }).then((result) => {
                if (!result.isConfirmed) {
                    if (data.can_reset) {
                        handleLoading(true)
                        Api.put(REQUEST_URLS.CAR_SERVICES.RESET_STEP, {
                            pid: pid,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${token}`
                            }
                        }).then((response) => {
                            if (!response.hasError) {
                                setOtpRequired(false)
                                handleGetProcess(pid)

                            } else {
                                handleLoading(false)
                                Swal.fire({
                                    allowOutsideClick: false,
                                    text: response.message,
                                    title: "ناموفق",
                                    icon: 'error',
                                    showCancelButton: false,
                                    confirmButtonColor: '#d51e3e',
                                    showConfirmButton: true,
                                    confirmButtonText: 'تلاش مجدد',
                                }).then(() => {

                                })
                            }

                        }).catch((e) => {

                            Swal.fire({
                                allowOutsideClick: false,
                                text: e.response.message,
                                title: "ناموفق",
                                icon: 'error',
                                showCancelButton: true,
                                cancelButtonColor: '#d51e3e',
                                showConfirmButton: false,
                                cancelButtonText: 'تلاش مجدد',
                            })
                            handleLoading(false)
                        }).finally(() => {

                        })
                    } else {

                        handleCreateProcess();
                    }
                } else {

                    onSkip();
                }
            })
        } else {

            callback()
        }
    }
    const handleServiceSelect = (newSelectedService) => {
        setSelectedServices(newSelectedService)
    }
    const handleShowReport = () => {
        setOpenReportModal(true)
    }
    const handleToggleAction = () => {
        setShowSupportActions(!showSupportActions)
    }
    const handleCarServiceWidget = (deleteType, pieceName, pid, postToken, callback = () => {
    }) => {
        handleLoading(true, 'در حال حذف افزونه')
        const dType = deleteType === 'full' ? 'full_widget' : 'piece_widget'
        Api.delete(REQUEST_URLS.CAR_SERVICES.DELETE_WIDGET, {
            params: {
                pid: pid,
                post_token: postToken,
                delete_type: dType,
                piece_name: pieceName,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((response) => {
            const {hasError, message} = response;

            if (!hasError) {

                if (deleteType === 'full') {
                    Swal.fire({
                        allowOutsideClick: false,
                        text: message,
                        title: "موفق",
                        icon: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'شروع مجدد',
                        confirmButtonColor: '#419e53'
                    }).then(result => {
                        if (result.isConfirmed) {
                            callback()
                        }
                    })
                } else {

                    handleInquiryProcess()
                }

            } else {
                Swal.fire({
                    allowOutsideClick: false,
                    text: message,
                    title: "خطا",
                    icon: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonColor: '#fd4747',
                    confirmButtonText: 'تلاش مجدد'
                }).then((result => {
                    if (result.isConfirmed) {
                        /*handleDeleteWidget(accessToken,postToken,callback)*/
                    }
                }))
            }
            handleLoading(false)
        }).catch((e) => {
            console.log(e)
            setLoading(false)
        })
    }
    return <div className="w-full pt-5 md:w-8/12 mx-auto lg:w-6/12   ">
        {openReportModal &&
            <BugModal accessToken={token} type="CService" requestUrl={'/api/v1/Providers/Reports/Create'}
                      onClose={() => {
                          setOpenReportModal(false);
                          setShowSupportActions(false)
                      }} data={bugReportData}/>}
        {!isLoading && <div>
            {showSupportActions && showReport && <button onClick={handleShowReport}
                                                         className="fixed bg-white border  shadow-2xl text-red-400   bottom-40 p-3  text-sm flex justify-center items-center rounded-full left-5 z-30">گزارش
                خطا</button>}
            {showSupportActions && <a href="tel:0119102001"
                                      className="fixed bg-white  border shadow-2xl text-gray-800      bottom-24  p-3  text-sm flex justify-center items-center rounded-full left-5 z-30"> تلفن
                پشتیبانی : ۰۱۱۹۱۰۱۲۰۰۱</a>}
            <button onClick={handleToggleAction}
                    className="fixed bg-white   border text-red-400  shadow-xl  bottom-24 p-3   flex justify-center items-center rounded-full  right-5 z-30">{showSupportActions ?
                <MdClose className="text-2xl"/> : <BiSupport className="text-2xl"/>}</button>
        </div>}
        {isLoading &&
            <div className="flex w-full left-0 h-screen fixed top-0 bg-gray-100 z-30 justify-center items-center ">
                <div className="w-6/12 mx-auto ">
                    <ProgressBar key={loadingMessage} message={loadingMessage} type="CService" duration={30}/>
                </div>
            </div>}
        <div className="w-11/12 mx-auto ">
            {processInfo && processInfo?.current_step?.name === "InitConfirm" && !otpRequired && <InitConfirm
                handleGetProcess={handleGetProcess}
                accessToken={token}
                pid={pid}
                handleConfirm={handleInitConfirm}
                handleServiceSelect={handleServiceSelect}
                selectedServices={selectedServices}
                prices={prices}
                processInfo={processInfo}/>}
            {processInfo && processInfo?.current_step?.name === "InitConfirm" && otpRequired &&
                <OTP key={otpTimer} length={otpConfig.length}
                     title={otpConfig.title}
                     timerCount={otpTimer}
                     handleRequestOTP={handleRequestOTP}
                     confirmLoading={otpConfirmLoading}
                     retryLoading={otpRequestLoading}
                     handleConfirm={handleConfirmOTP}
                     error={otpError}
                     description={otpDescription}
                />}
            {processInfo && (processInfo?.current_step?.name === "CreatePayment" || processInfo?.current_step?.name === "InquiryPayment") &&
                <CreatePaymentCard
                    processInfo={processInfo}
                    handleCreateProcess={handleCreatePayment}/>}
        </div>
        <div className="w-11/12 mx-auto">
            {processInfo && processInfo?.current_step?.name === "final" && <div
                className="w-full p-7 flex justify-center items-center flex-col  rounded-lg bg-white shadow-sm    ">
                <TbShieldCheckFilled className="text-green-500 text-6xl "/>
                <p className=" font-bold mt-5 mb-1  text-center">اصالت خودرو با موفقیت انجام شد.</p>
                <p className=" text-sm mt-1 mb-3  text-center">مشخصات خودروی شما روی آگهی درج گردید.</p>
                <div className="mt-3 grid w-full  gap-3">
                    <div className="mt-3 grid w-full grid-cols-1 gap-3">
                        <Button onClick={() => handleRedirectToDivar({
                            status: "success",
                            price: processInfo?.payment?.info?.init_amount
                        })} rounded="rounded-lg w-full"
                                theme="blue">بازگشت </Button>
                    </div>
                </div>
            </div>
            }
        </div>

    </div>
}
export default CarOriginality;